module.exports = __webpack_public_path__ + "static/media/bg-premium.cf887869.png";